import { deleteProducer } from "containers/ProducersPage/slice";
import { selectPagination } from "containers/ProducersPage/slice/selectors";
import { IProducerOut } from "openapi/types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Text } from "atoms";
import { IconButton } from "@mui/material";
import { Cancel, Edit } from "@mui/icons-material";
import { ConfirmationDialogue } from "components/ConfirmationDialogue/ConfirmationDialogue";
import { AddProducerModal } from "../ProducerModal/AddProducerModal";

interface IProducerRowProps {
  producer: IProducerOut;
}

export const ProducerRow = ({ producer }: IProducerRowProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [confirmVisibility, setConfirmVisibility] = useState(false);
  const pagination = useSelector(selectPagination);
  const dispatch = useDispatch();

  const onAction = () => {
    if (producer.producerId) {
      dispatch(
        deleteProducer({
          producerId: producer.producerId,
          pagination,
        })
      );
    }
  };

  return (
    <tr style={{ borderTop: "1px solid #e8e8e8", height: "63px" }}>
      <th>
        <Text bold>{producer.name}</Text>
      </th>
      <td>
        <Text bold>{producer.address?.county}</Text>
      </td>
      <td>
        <Text bold>{producer.address?.city}</Text>
      </td>
      <td>
        <Text bold>{producer.address?.address}</Text>
      </td>
      <td>
        <IconButton className="mr-2" onClick={() => setIsVisible(true)}>
          <Edit />
        </IconButton>
        <IconButton onClick={() => setConfirmVisibility(true)}>
          <Cancel />
        </IconButton>
      </td>
      {isVisible && (
        <AddProducerModal
          onClose={() => setIsVisible(false)}
          producer={producer}
        />
      )}
      {confirmVisibility && (
        <ConfirmationDialogue
          onClose={() => setConfirmVisibility(false)}
          description="Ești sigur că vrei să ștergi acest producător?"
          onConfirm={onAction}
        />
      )}
    </tr>
  );
};
